export function getOperators () {
  return [
    {
      key: 'eq',
      label: '=',
      value: 'eq'
    },
    {
      key: 'gt',
      label: '>',
      value: 'gt'
    },
    {
      key: 'geq',
      label: '≥',
      value: 'geq'
    },
    {
      key: 'lt',
      label: '<',
      value: 'lt'
    },
    {
      key: 'leq',
      label: '≤',
      value: 'leq'
    },
    {
      key: 'neq',
      label: '≠',
      value: 'neq'
    }
  ]
}

export function getPostData (data, uid) {
  return {
    actions: [{
      title: data.title,
      body: data.message
    }],
    event: {
      source: 'device',
      resource: data.ruleType,
      type: 'exohomeEvent',
      conditions: [{
        key: data.conditions.key,
        op: data.conditions.op,
        target: Number(data.conditions.target)
      }]
    },
    familyMembers: data.familyNames.reduce((acc, curr) => acc.concat(data.familyMembers[curr]), []),
    familyName: data.familyNames,
    ownerId: uid,
    source: 'admin'
  }
}

export default {
  getOperators,
  getPostData
}



// WEBPACK FOOTER //
// ./src/components/NotificationsCreate/helper.js